import { EmptyState } from '@chronospeak/ui';
import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <main style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center' }}>
      <EmptyState title='内容不存在或已下线' description='这扇门后面还没有故事。'>
        <Link to='/zh-CN'>回到首页</Link>
      </EmptyState>
    </main>
  );
}
